export default __webpack_public_path__ + "assets/980f51fe02c1b4e6018978f5ac2f1025.png";